// extracted by mini-css-extract-plugin
export default {"breadcrumbSeperator":"BreadcrumbsSection-module__breadcrumbSeperator___g4Pn9"};